import { RootState } from '@share/utils';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getActivityFilterValues, isActivityFiltersEmpty } from '@utils';
import { activityFiltersActions } from '@share/store/slices';
import { HomesTypes } from '@share/constants';

import { IAccount } from '@share/common-types';

import { ActivitySelectedFiltersItem } from '../selected-filters-item';

import './style.scss';

interface IProps {
  title?: string;

  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;

  isCentered?: boolean;
  displayClearAll?: boolean;
  displayClearAllHeader?: boolean;

  onFiltersOrSortChange: (isSortChange?: boolean) => void;
}

export function ActivitySelectedFiltersBase(props: IProps) {
  const { isCars, isVacationRentals, isCentered, displayClearAll, displayClearAllHeader, title, onFiltersOrSortChange } = props;

  const activityStore = useSelector((state: RootState) => state.activityStore);
  const activityFiltersStore = useSelector((state: RootState) => state.activityFiltersStore);

  const account = useSelector((state: RootState) => state.loginStore.account);

  const { loadingFilter: loadingFilterHotels } = activityStore;

  const { searchHomes } = activityFiltersStore;

  const isFiltersAppliedHotels = !isActivityFiltersEmpty(activityFiltersStore, (account as IAccount)?.isCapitalVacations);

  const isSearchHomesApplied = !isCars && !isVacationRentals && searchHomes !== HomesTypes.All;

  const filterValues = getActivityFilterValues(activityFiltersStore);

  const dispatch = useDispatch();

  const loadingFilter = loadingFilterHotels;
  const isFiltersApplied = isFiltersAppliedHotels;

  if (!isFiltersApplied || loadingFilter || (!filterValues.length && !isSearchHomesApplied)) {
    return null;
  }

  const handleClearAll = () => {
    dispatch(activityFiltersActions.resetFilters((account as IAccount)?.isCapitalVacations));
    onFiltersOrSortChange(true);
  };
  return (
    <div className={`activity-selected-filters-header ${isCentered ? 'centered-values' : ''}`}>
      {title && (
        <div className="activity-selected-filters-header__title">
          <FormattedMessage id={title} />
        </div>)}

      <ActivitySelectedFiltersItem isVacationRentals={isVacationRentals} isCars={isCars} onFiltersOrSortChange={onFiltersOrSortChange} displayClearAll={displayClearAllHeader} />

      {displayClearAll && filterValues.length > 1 && (
        <div className="activity-selected-filters-header__clear-all" onClick={handleClearAll}>
          <FormattedMessage id="clearAll" />
        </div>)}
    </div>
  );
}
